/* eslint-disable @next/next/no-img-element */
'use client'
import { ContainerCustom, Image, LoadingScreen } from '@/components'
import { SOCIAL_LINKS } from '@/config/global-config'
import { URL_DECOR, URL_ICON } from '@/constants/ui'
import { Logo } from '@/layouts/header/v1/components'
import { UserLogin } from '@/layouts/header/v2/components/user-login'
import { TypePopup, useUpsellStore } from '@/store/upsell'
import { getVND } from '@/utils/helpers'
import {
  Box,
  Divider,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { useRouter } from 'next/navigation'
import { parseAsString, useQueryState } from 'nuqs'
import { useEffect } from 'react'
import { Icon } from '../../../cart/components/icon'
import { ReturnTag } from '../../../cart/components/return-tag'
import { BtnQrCode } from '../../components/btn-qr-code'
import { CopyBtn } from '../../components/copy-btn'
import { ExpiredTransaction } from '../../components/expired-transaction'
import { getOrderInfoPlaceOrder, getOrderStatus, getQrPayment } from '../../services'

// import { useRouter } from '@/libs/i18n/routing'
export const Payment = () => {
  const t = useTranslations()
  const router = useRouter()
  const [orderCode] = useQueryState('order', parseAsString.withDefault(''))
  const { setOrderCode, clearOrderCode } = useUpsellStore()
  const { data, isLoading } = useQuery({
    queryKey: ['ORDER_INFO', orderCode],
    queryFn: () => getOrderInfoPlaceOrder(orderCode),
    gcTime: 0,
    staleTime: 0,
    enabled: !!orderCode,
  })
  const { data: orderStatus } = useQuery({
    queryKey: ['ORDER_STATUS', orderCode],
    queryFn: async () =>
      await getOrderStatus(orderCode).then((res) => {
        console.log('order status', res)
        if (res.state == 'processing') {
          clearOrderCode()
          window.location.href =
            '/payment/success' +
            '?order=' +
            data?.orderV2?.entity_id +
            '&code=' +
            orderCode +
            '&protect=' +
            data?.orderV2?.protect_code
        }
        return res
      }),
    refetchInterval: 1000 * 10,
    enabled: !!orderCode,
    refetchOnWindowFocus: true,
  })
  const { data: qrData, isLoading: isLoadingQR } = useQuery({
    queryKey: ['QR_PAYMENT', orderCode],
    queryFn: () =>
      getQrPayment({
        accountNo: data?.payment?.account_number,
        accountName: data?.payment?.account,
        acqId: data?.payment?.bank_id,
        amount: data?.orderV2?.grand_total?.value || 0,
        addInfo: data?.orderV2?.order_number,
        format: 'text',
        template: data?.payment?.qr_logo,
      }),
    enabled: !!data?.payment?.account_number && !!data?.orderV2?.grand_total,
  })

  //save the order code to useUpsellStore
  useEffect(() => {
    if (orderCode) {
      setOrderCode(orderCode, TypePopup.PAYMENT)
    }
  }, [orderCode, setOrderCode])

  if (isLoading || isLoadingQR) {
    return <LoadingScreen />
  }
  const list = [
    {
      title: 'Ngân hàng:',
      content: (
        <img
          src={data?.payment?.bank_logo || URL_ICON + 'bank-acb.png'}
          alt={'Ngân hàng ' + (data?.payment?.bank || 'ACB')}
          style={{ width: 'auto', height: '24px' }}
        />
      ),
    },
    {
      title: 'Số tài khoản:',
      content: (
        <Typography component={'span'} variant="body2" fontWeight={600}>
          {data?.payment?.account_number}{' '}
          {data?.payment?.account_note ? <span>({data?.payment?.account_note})</span> : null}
        </Typography>
      ),
    },
    {
      title: 'Đơn vị thụ hưởng:',
      content: (
        <Typography component={'span'} variant="body2" fontWeight={600}>
          {data?.payment?.account || 'VY NGUYEN KHANH HUNG'}
        </Typography>
      ),
    },
    {
      title: 'Mã đơn hàng:',
      content: (
        <Typography component={'span'} variant="body2" fontWeight={600}>
          {data?.orderV2?.order_number}
        </Typography>
      ),
    },
    {
      title: 'Số tiền thanh toán:',
      content: (
        <Typography
          component={'span'}
          sx={{ fontSize: { xs: '1.125rem', md: '1.25rem', lg: '1.5rem' } }}
          fontWeight={600}
        >
          {getVND(data?.orderV2?.grand_total?.value || 0, 'Đ')}
        </Typography>
      ),
    },
    {
      title: 'Nội dung giao dịch:',
      content: (
        <Box component={'span'} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography component={'span'} variant="body2" fontWeight={600}>
            {data?.orderV2?.order_number}
          </Typography>
          <CopyBtn
            code={data?.orderV2?.order_number || ''}
            props={{ sx: { fontSize: '1rem', cursor: 'pointer' } }}
          />
        </Box>
      ),
    },
  ]
  return (
    <ContainerCustom>
      <Box
        sx={{
          maxWidth: '1324px',
          margin: '0 auto',
          paddingY: { xs: 4, md: 6, lg: 7 },
          paddingX: { xs: 0, sm: 2, lg: 4, xxl: 8 },
        }}
      >
        <Stack spacing={{ xs: 2, md: 4 }}>
          <Stack direction={'row'} spacing={2} alignItems={'end'} justifyContent={'space-between'}>
            <Logo />
            <UserLogin />
          </Stack>
          <Divider sx={{ width: '100%', height: '1px', backgroundColor: '#BBBBBA' }} />
          <Grid
            container
            spacing={{ xs: 2, md: 4 }}
            flexDirection={{
              xs: 'column-reverse',
              lg: 'row',
            }}
            justifyContent={{ xs: 'center', lg: 'space-between' }}
          >
            <Grid size={{ xs: 12, lg: 6 }}>
              <Stack spacing={2}>
                <Typography variant="h4" fontWeight={600} sx={{ fontSize: { xs: '1.5rem', md: '2rem' } }}>
                  Quét mã QR qua app ngân hàng hoặc ví điện tử
                </Typography>
                <Stack spacing={1}>
                  <Stack direction={'row'} alignItems={'start'} spacing={1}>
                    <Icon.Light sx={{ fontSize: '1rem' }} />
                    <Typography variant="body2" fontWeight={300}>
                      Mở ứng dụng ngân hàng bất kỳ để{' '}
                      <Box component={'span'} fontWeight={600}>
                        quét mã QR
                      </Box>{' '}
                      hoặc{' '}
                      <Box component={'span'} fontWeight={600}>
                        chuyển khoản
                      </Box>{' '}
                      theo chính xác nội dung bên dưới:
                    </Typography>
                  </Stack>
                  <Box
                    sx={{
                      border: '1px solid #BBBBBA',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      padding: '12px',
                    }}
                  >
                    {/* MUI Table */}
                    <TableContainer>
                      <Table sx={{ minWidth: 300 }}>
                        {/* Table Body */}
                        <TableBody>
                          {list.map((item, index) => (
                            <TableRow
                              key={index}
                              sx={{
                                '& td': {
                                  borderBottom: '1px solid #BBBBBA',
                                  py: '12px',
                                },
                                '&:last-child td': {
                                  borderBottom: 0,
                                  paddingBottom: 0,
                                },
                                '&:first-child td': {
                                  paddingTop: 0,
                                },
                              }}
                            >
                              <TableCell align="left" padding="none">
                                <Typography variant="body2" fontWeight={300}>
                                  {item.title}
                                </Typography>
                              </TableCell>
                              <TableCell align="left" padding="none">
                                <Typography variant="body2" fontWeight={600}>
                                  {item.content}
                                </Typography>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                  <WarningText />
                </Stack>
                <ReturnTag props={{ sx: { width: { xs: '100%', xsm: 'fit-content' } } }} />
                <LoadingState />
                <NoteText />
              </Stack>
            </Grid>
            <Grid
              size={{ xs: 12, lg: 6 }}
              sx={{ display: 'flex', alignItems: { xs: 'center', lg: 'flex-end' }, flexDirection: 'column' }}
            >
              <Stack spacing={2} alignItems={'center'} justifyContent={'center'}>
                <TitleQrCode />
                <Stack spacing={1} alignItems={'center'} justifyContent={'center'}>
                  <Typography variant="body2" fontWeight={300}>
                    Giao dịch sẽ hết hạn sau:
                  </Typography>
                  <ExpiredTransaction
                    expiryTime={data?.orderV2?.expire_at || ''}
                    onExpired={() => {
                      console.log('transaction expired')
                      clearOrderCode()
                      // navigateWhenVisible('/')
                      setTimeout(() => {
                        window.location.href = '/'
                      }, 50)
                    }}
                  />
                </Stack>
                <Stack spacing={2} sx={{ maxWidth: '270px', minWidth: '200px' }}>
                  <Image
                    src={qrData?.data?.qrDataURL || URL_DECOR + 'fake_qr_code.png'}
                    alt="qr-code"
                    style={{ width: '100%', height: 'auto', pointerEvents: 'none' }}
                  />
                  <Stack spacing={1}>
                    <BtnQrCode link={qrData?.data?.qrDataURL || URL_DECOR + 'fake_qr_code.png'} />
                    {/* <Button
                      LinkComponent={Link}
                      href="/cart"
                      variant="text"
                      sx={{
                        color: 'primary.main',
                        textTransform: 'none',
                        padding: { xs: '8px 12px', md: '12px 20px' },
                        fontSize: { xs: '0.75rem', md: '0.875rem' },
                        borderRadius: '8px',
                        width: '100%',
                      }}
                    >
                      {t('Hủy thanh toán')}
                    </Button> */}
                  </Stack>
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </Stack>
      </Box>
    </ContainerCustom>
  )
}

const LoadingState = () => {
  return (
    <Stack
      direction={'row'}
      sx={{ padding: '12px', borderRadius: '8px', background: '#F4F5F8' }}
      spacing={1}
      alignItems={'center'}
      justifyContent={'flex-start'}
    >
      {/* loading icon */}
      <Icon.Loading sx={{ width: '20px', height: '20px' }} />
      <Typography variant="body2" fontWeight={300}>
        Vui lòng không tải lại trang. Hệ thống đang kiểm tra giao dịch
      </Typography>
    </Stack>
  )
}

const NoteText = () => {
  return (
    <Typography variant="body2" fontWeight={300}>
      Nếu trong vòng{' '}
      <Box component={'span'} fontWeight={600}>
        3 phút
      </Box>{' '}
      sau khi đã thanh toán, hệ thống không tự động chuyển hướng. Liên hệ ngay đến{' '}
      <Typography component={Link} href={SOCIAL_LINKS.facebook} fontWeight={600}>
        Admin HYDRASHOP
      </Typography>{' '}
      để được hỗ trợ vấn đề kỹ thuật
    </Typography>
  )
}

const WarningText = () => {
  return (
    <Typography variant="body2" fontWeight={300} sx={{ color: '#F04438' }}>
      *Đây là tính năng chuyển khoản{' '}
      <Box component={'span'} fontWeight={600}>
        HOÀN TOÀN TỰ ĐỘNG.
      </Box>{' '}
      Bạn hãy chuyển{' '}
      <Box component={'span'} fontWeight={600}>
        ĐÚNG SỐ TIỀN VÀ ĐÚNG NỘI DUNG CHUYỂN KHOẢN
      </Box>
    </Typography>
  )
}

const TitleQrCode = () => {
  return (
    <Stack alignItems={'center'} justifyContent={'center'}>
      <Typography
        fontWeight={600}
        textAlign={'center'}
        sx={{ fontSize: { xs: '1.125rem', md: '1.5rem' }, width: 'fit-content' }}
      >
        GIÁ HIỆN TẠI ĐANG LÀ GIÁ{' '}
      </Typography>
      <Typography
        fontWeight={600}
        textAlign={'center'}
        sx={{ fontSize: { xs: '1.125rem', md: '1.5rem' }, width: 'fit-content' }}
      >
        ƯU ĐÃI NHẤT DÀNH CHO BẠN!
      </Typography>
    </Stack>
  )
}
